module.exports = __webpack_public_path__ + "img/de.74018f0a.svg";